/**
 *  Turns out GitHub Markdown has some heuristics around dollar signs as well.
 *  Their approach seems to be (roughly speaking):
 *  - "<non-letter>$<letter>" is an opening math delimiter ("letter" includes digits here)
 *  - "<letter>$<non-letter>" is a closing math delimiter
 *  - anything else is a literal dollar sign
 *
 *  Examples:
 *  - "$x$" -> math
 *  - "$x" -> literal
 *  - "$100 $200" -> literal
 *  - "$100 x$." -> math
 *
 *  However:
 *  - "$ x $" -> literal (because of the space after the first $)
 */

// TODO: consider using GitHub approach

export function sanitizeDollarSigns(str: string) {
  // if single "$" has more matches than "$<number>", that's probably latex (return as is)
  const dollarMatches = str.match(/(?<![$\\])\$(?![$])/g)?.length ?? 0;
  const dollarNumberMatches = str.match(/(?<![$\\])\$\d/g)?.length ?? 0;

  if (dollarMatches > dollarNumberMatches) {
    return str;
  }

  return str.replace(
    /(?<![$\\])\$([\d]+|[\d]+\.[\d]*|[\d]*\.[\d]+)(?![\d.$])/g,
    (_, m) => `\\$${m}`,
  );
}
